var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19C0 19.5523 0.447715 20 1 20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H2L2 1C2 0.447715 1.55228 0 0.999999 0C0.447714 0 0 0.447715 0 1V19ZM5 16C4.44772 16 4 15.5523 4 15L4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8L6 15C6 15.5523 5.55229 16 5 16ZM8 15C8 15.5523 8.44772 16 9 16C9.55229 16 10 15.5523 10 15V5C10 4.44772 9.55228 4 9 4C8.44771 4 8 4.44771 8 5L8 15ZM13 16C12.4477 16 12 15.5523 12 15V11C12 10.4477 12.4477 10 13 10C13.5523 10 14 10.4477 14 11V15C14 15.5523 13.5523 16 13 16ZM16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15V8C18 7.44772 17.5523 7 17 7C16.4477 7 16 7.44772 16 8V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.f8f5c5f3.svg";
export { ForwardRef as ReactComponent };